import { Redirect } from 'expo-router';

/** O spike do Connect é só nativo (`connect-spike-screen.tsx`); na web volta pro início. */
export function ConnectSpikeScreen() {
  return <Redirect href="/" />;
}
